import { config } from "../config";

export const useImageSrc = (key) => {
  if (!key) return undefined;

  return `${config.imageUrl}/${key}`;
};
